"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const workbox_window_1 = require("workbox-window");
// eslint-disable-next-line no-undef
if ("serviceWorker" in navigator) {
    // eslint-disable-next-line no-undef
    const wb = new workbox_window_1.Workbox(__SERVICE_WORKER_SW_DEST__, {
        // eslint-disable-next-line no-undef
        scope: __SERVICE_WORKER_SCOPE__,
    });
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    wb.register();
}
